import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.survey')
  .factory('$survey', surveyObjectFactory);

/* @ngInject */
function surveyObjectFactory($bringozFactory: $bringozFactory,
                             SurveyAPI: BringozApi,
                             Survey_DS: DataStoreConfig,
                             Survey_PN: PushNotificationsConfig) {
  function $survey(id: string) {
    return $bringozFactory(id, SurveyAPI, Survey_DS, Survey_PN)
  }

  return $survey
}
